import {Component, Input} from '@angular/core';
import {FormError} from '../../../tools/form-error/form-error';
import {NgForOf, NgIf} from '@angular/common';
import {TranslatePipe} from '@ngx-translate/core';

@Component({
  selector: 'app-form-error',
  imports: [
    NgForOf,
    NgIf,
    TranslatePipe
  ],
  templateUrl: './form-error.component.html',
  styleUrl: './form-error.component.scss'
})
export class FormErrorComponent {
  @Input() formFieldName: string = '';
  @Input() formError: FormError = new FormError();

  getErrors(): string[] {
    return this.formError.getErrors(this.formFieldName);
  }

  hasErrors(): boolean {
    return !!this.getErrors().length;
  }
}
